import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export default function Reveal({ children, delay = 0, y = 32, className = "", amount = 0.15 }) {
    const reduce = useReducedMotion();
    return (
        <motion.div
            className={className}
            initial={reduce ? false : { opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount }}
            transition={{ duration: 0.9, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export function LineReveal({ children, delay = 0, className = "" }) {
    const reduce = useReducedMotion();
    return (
        <motion.span
            className={`block overflow-hidden ${className}`}
            initial={reduce ? false : "hidden"}
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
        >
            <motion.span
                className="block will-change-transform"
                variants={{
                    hidden: { y: "110%" },
                    show: { y: 0, transition: { duration: 0.9, delay, ease: EASE } },
                }}
            >
                {children}
            </motion.span>
        </motion.span>
    );
}
